import React, {Component} from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import Datetime from 'react-datetime';
import {Alert, Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Media, Row} from 'reactstrap';

import {closeAlert} from '../../../actions/commonsActions';
import {fetchOperatorStatByCompaniesCsv, fetchOperatorStatsByCompanies} from '../../../actions/operatorStatsActions';
import {fetchCompanies, fetchTinyCompaniesWithOperator} from '../../../actions/companyActions';
import {PAGINATION_DEFAULT_LIMIT, USER_ROLES} from '../../../helpers/constants';
import Pagination from '../../Pagination/Pagination';
import {I18n} from "../../../I18n/components/statistics";

import 'react-datetime/css/react-datetime.css';
import 'react-table/react-table.css';
import '../../Statistics/CompaniesStat/companies-stat.css';
import spinner from "../../../assets/images/spinner.gif";
import {fetchTinyStoresWithOperatorCsv} from "../../../actions/storesActions";
import {createCsv} from "../../../helpers/createCsv";

class OperatorStatByCompanies extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
            dateTo: moment().format('YYYY-MM-DD'),
            companyNameFilter: null,
            currentPage: 0,
            isStatsCsvDownload: false,
            isConnectedStoresCsvDownload: false,
        };
    }

    componentDidMount() {
        (async () => {
            await this.props.fetchTinyCompaniesWithOperator(this.props.companies[0].id);
            await this.fetchPaginatedData(0);
        })();
    }

    onFilterClick = event => {
        this.setState({
            companyNameFilter: event.target.value
        })
    };

    dateToTimeChange = moment => {
        this.setState({
            dateTo: moment.format('YYYY-MM-DD')
        })
    };

    dateFromTimeChange = moment => {
        this.setState({
            dateFrom: moment.format('YYYY-MM-DD')
        })
    };

    getFiltered = async () => {
        await this.fetchPaginatedData(0);
    };

    fetchPaginatedData = currentPage => {
        this.props.fetchOperatorStatsByCompanies({
            operatorCompanyId: this.props.companies[0].id,
            companyNameFilter: this.state.companyNameFilter,
            dateFrom: this.state.dateFrom,
            dateTo: this.state.dateTo,
            page: currentPage,
        }).then(() => {
            this.setState({
                currentPage,
            });
        });
    };

    setCurrentPage = async currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage)
        });
    };

    clearFilters = () => {
        this.setState({
            dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
            dateTo: moment().format('YYYY-MM-DD')
        }, async () => {
            await this.fetchPaginatedData(0);
        })
    };

    downloadStatsCsv = () => {
        const {dateTo, dateFrom, companyNameFilter} = this.state;
        this.setState({
            isStatsCsvDownload: true
        }, async () => {
            const operatorCompanyId = this.props.companies[0].id;
            const response = await this.props.fetchOperatorStatByCompaniesCsv({
                operatorCompanyId,
                companyNameFilter,
                dateTo,
                dateFrom
            });
            this.createCsvIfResponseExists(response);
            this.setState({
                isStatsCsvDownload: false
            })
        })
    }

    downloadConnectedStoresCsv = () => {
        this.setState({
            isConnectedStoresCsvDownload: true
        }, async () => {
            const operatorCompanyId = this.props.companies[0].id;
            const response = await this.props.fetchTinyStoresWithOperatorCsv({
                operatorCompanyId
            });
            this.createCsvIfResponseExists(response);
            this.setState({
                isConnectedStoresCsvDownload: false
            })
        })
    }

    createCsvIfResponseExists = response => {
        if (response) {
            createCsv(response);
        }
    }

    render() {
        const {lang} = this.props;
        return (
            <div className='companies-stats'>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-city mr-2"></i>{I18n[lang].companies.title}
                        </div>
                    </CardTitle>

                    <CardBody>
                        {
                            (() => {
                                const {statsLoading, tinyCompaniesWithOperator, operatorStats} = this.props;
                                if (statsLoading) {
                                    return <div className="loading">Loading...</div>;
                                } else {
                                    let firstElementNumber = this.state.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
                                    const tableData = operatorStats.map(stat => {
                                        const company = tinyCompaniesWithOperator.find(company => company.id === stat.companyId)
                                        return {
                                            count_id: firstElementNumber++,
                                            id: company.id,
                                            companyId: company.id,
                                            name: company.name,
                                            stores: stat.totalSalesPoints,
                                            storesActive: stat.activeSalesPoints,
                                            totalAppInstalls: stat.totalAppInstalls,
                                            devices: stat.totalDevices
                                        };
                                    });
                                    return (
                                        <div>
                                            <Row>
                                                <Col lg="12">
                                                    <FormGroup>
                                                        <Input
                                                            className="company-search-filter"
                                                            type="text"
                                                            name="search"
                                                            id="search"
                                                            value={this.state.companyNameFilter}
                                                            onChange={this.onFilterClick}
                                                            placeholder={I18n[lang].companies.placeholder}
                                                        />
                                                        <Datetime
                                                            className="company-data-filter"
                                                            locale="en-gb"
                                                            timeFormat={false}
                                                            inputProps={{
                                                                placeholder: `${I18n[lang].companies.dateFrom}`,
                                                                readOnly: true
                                                            }}
                                                            onChange={this.dateFromTimeChange}
                                                            closeOnSelect={true}
                                                            value={this.state.dateFrom ? moment(this.state.dateFrom).format('DD.MM.YYYY') : ''}
                                                        />
                                                        <Datetime
                                                            className="company-data-filter date-to"
                                                            locale="en-gb"
                                                            timeFormat={false}
                                                            closeOnSelect={true}
                                                            inputProps={{
                                                                placeholder: `${I18n[lang].companies.dateTo}`,
                                                                readOnly: true
                                                            }}
                                                            onChange={this.dateToTimeChange}
                                                            value={this.state.dateTo ? moment(this.state.dateTo).format('DD.MM.YYYY') : ''}
                                                        />
                                                        <div className="company-btn__group">
                                                            <Button
                                                                color="primary"
                                                                type="button"
                                                                className="company-btn btn-filter"
                                                                onClick={this.getFiltered}
                                                            >
                                                                {I18n[lang].companies.filter}
                                                            </Button>
                                                            <Button
                                                                color="primary"
                                                                type="button"
                                                                className="company-btn btn-clear"
                                                                onClick={this.clearFilters}
                                                            >
                                                                {I18n[lang].companies.resetFilter}
                                                            </Button>
                                                            <Media
                                                                className={!this.state.isStatsCsvDownload ?
                                                                    'company-btn__spinner visually-hidden' : 'company-btn__spinner'}
                                                                object
                                                                src={spinner}
                                                                alt="Generic placeholder image"
                                                            />
                                                            <Button
                                                                color="secondary"
                                                                type="button"
                                                                className={this.state.isStatsCsvDownload ?
                                                                    'company-btn apk__download invisible' :
                                                                    'company-btn apk__download visible'}
                                                                onClick={this.downloadStatsCsv}
                                                            >
                                                                {I18n[lang].companies.download}
                                                            </Button>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <div className="company-btn__group">
                                                            <Media
                                                                className={!this.state.isConnectedStoresCsvDownload ?
                                                                    'company-btn__spinner visually-hidden' : 'company-btn__spinner'}
                                                                object
                                                                src={spinner}
                                                                alt="Generic placeholder image"
                                                            />
                                                            <Button
                                                                color="secondary"
                                                                type="button"
                                                                className={this.state.isConnectedStoresCsvDownload ?
                                                                    'invisible' :
                                                                    'visible'}
                                                                onClick={this.downloadConnectedStoresCsv}
                                                            >
                                                                {I18n[lang].companies.downloadConnectedStoresCsv}
                                                            </Button>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <div className="stat-table">
                                                <ReactTable
                                                    getProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            style: {
                                                                border: "none",
                                                                padding: "5px"
                                                            }
                                                        };
                                                    }}
                                                    getTheadProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            style: {
                                                                boxShadow: "none",
                                                                padding: "10px 0",
                                                                fontWeight: "600"
                                                            }
                                                        };
                                                    }}
                                                    getTheadThProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            style: {
                                                                borderRight: "none"
                                                            }
                                                        };
                                                    }}
                                                    getTdProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            style: {
                                                                borderRight: "none",
                                                                textAlign: "center"
                                                            }
                                                        };
                                                    }}
                                                    getTrProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            onClick: () => {
                                                                const {dateFrom, dateTo} = this.state;
                                                                this.props.changeLocation(`/dashboard/statistics/stores?retailCompanyId=${rowInfo.original.companyId}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
                                                            },
                                                            style: {
                                                                alignItems: "center"
                                                            }
                                                        }
                                                    }}
                                                    getNoDataProps={(state, rowInfo, column, instance) => {
                                                        return {
                                                            style: {
                                                                top: "100%"
                                                            }
                                                        };
                                                    }}
                                                    columns={[
                                                        {
                                                            Header: "#",
                                                            accessor: "count_id",
                                                            sortable: false,
                                                            filterable: false,
                                                            style: {
                                                                textAlign: "left",
                                                                fontSize: "0.7rem",
                                                                textTransform: "lowercase"
                                                            },
                                                            maxWidth: 40
                                                        },
                                                        {
                                                            Header: `${I18n[lang].companies.traderName}`,
                                                            accessor: "name",
                                                            sortable: false,
                                                            filterable: false,
                                                            minWidth: 200,
                                                            style: {
                                                                textAlign: "left"
                                                            }
                                                        },
                                                        {
                                                            Header: `${I18n[lang].companies.tt}`,
                                                            accessor: "stores",
                                                            sortable: false,
                                                            filterable: false,
                                                            style: {
                                                                fontSize: "0.7rem",
                                                                textAlign: "center"
                                                            }
                                                        },
                                                        {
                                                            Header: `${I18n[lang].companies.activeTT}`,
                                                            accessor: "storesActive",
                                                            sortable: false,
                                                            filterable: false,
                                                            style: {
                                                                fontSize: "0.7rem",
                                                                textAlign: "center"
                                                            },
                                                        },
                                                        {
                                                            Header: `${I18n[lang].companies.apps}`,
                                                            accessor: "totalAppInstalls",
                                                            sortable: false,
                                                            filterable: false,
                                                            maxWidth: 110,
                                                            style: {
                                                                fontSize: "0.7rem",
                                                                textAlign: "center"
                                                            },
                                                        },
                                                        {
                                                            Header: `${I18n[lang].companies.devices}`,
                                                            accessor: "devices",
                                                            sortable: false,
                                                            filterable: false,
                                                            style: {
                                                                fontSize: "0.7rem",
                                                                textAlign: "center"
                                                            },
                                                        },
                                                    ]}
                                                    PaginationComponent={Pagination}
                                                    nextText={">>"}
                                                    previousText={"<<"}
                                                    defaultPageSize={-1}
                                                    pageSize={tableData.length}
                                                    showPaginationBottom={this.props.pagination.totalPages > 1}
                                                    className="-highlight"
                                                    data={tableData}
                                                    filterable
                                                    manual
                                                    onPageChange={this.setCurrentPage}
                                                    page={this.state.currentPage}
                                                    pages={this.props.pagination.totalPages}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                            })()
                        }
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: (url) => dispatch(push(url)),
        fetchCompanies: (query) => dispatch(fetchCompanies(query)),
        fetchTinyCompaniesWithOperator: query => dispatch(fetchTinyCompaniesWithOperator(query)),
        fetchOperatorStatsByCompanies: query => dispatch(fetchOperatorStatsByCompanies(query)),
        fetchOperatorStatByCompaniesCsv: query => dispatch(fetchOperatorStatByCompaniesCsv(query)),
        fetchTinyStoresWithOperatorCsv: operatorCompanyId => dispatch(fetchTinyStoresWithOperatorCsv(operatorCompanyId)),
    }
};

const mapStateToProps = state => ({
    alert: state.alert,
    companies: state.companiesReducer.companies,
    tinyCompaniesWithOperator: state.tinyCompaniesWithOperatorReducer.tinyCompanies,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    operatorStats: state.operatorStatsByCompaniesReducer.operatorStats,
    pagination: state.operatorStatsByCompaniesReducer.pagination,
    statsLoading: state.operatorStatsByCompaniesReducer.loading,
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(OperatorStatByCompanies)


// WEBPACK FOOTER //
// ./src/components/OperatorStat/OperatorStatByCompanies/OperatorStatByCompanies.js